import { Button } from "@mui/material";
import Typography from "@mui/material/Typography";
import { useTranslation } from "react-i18next";

import { getTimeFromDatetime } from "~/lib/helpers";

import {
  hasEventType,
  hasText,
  hasDeviceId,
  hasTote,
  isAutostoreEvent,
  isHandToggled
} from "./andon.logic";
import { AndonEventWithMeta } from "./andon.types";
import { mapEventColorAndLetters } from "./andon.utils";

type EventInfoBoxProps = {
  andonEvent: AndonEventWithMeta;
  onClickCb?: () => void;
};

export function EventInfoBox({ andonEvent, onClickCb }: EventInfoBoxProps) {
  const { t } = useTranslation();
  const { status, event, hub, timestamp, binId } = andonEvent;

  let eventTextColor = "black";
  let eventTypeText = "";
  let eventSupplementalText = "";

  if (hasEventType(event)) {
    switch (event.eventType) {
      case "Completed":
        eventTypeText = t("completed");
        break;
      case "Picked":
        eventTypeText = t("picked");
        break;
      case "pick":
        eventTypeText = t("nav.link.pick");
        break;
      case "Selected":
        eventTypeText = t("selected");
        break;
      case "Position Confirmed":
        eventTypeText = t("position confirmed");
        if (hasTote(event)) {
          eventSupplementalText = `pos: ${event.tote.totePosition || ""}`;
        }
        break;
      case "LabelPlaced":
        eventTypeText = t("label placed");
        break;
      case "StateChange":
        eventTypeText = t("state change");
        if (hasDeviceId(event) && hasText(event)) {
          eventSupplementalText = `id: ${event.deviceId} - ${
            event.data.text || ""
          }`;
        }
        break;
      case "PickingStarted":
        eventTypeText = t("picking started");
        break;
      default:
        eventTypeText = event.eventType;
        break;
    }
  }

  if (isAutostoreEvent(event)) {
    switch (event.case) {
      case "PTLMessageActivated":
        eventTypeText = t("ptl activated");
        break;
      case "PTLMessageRegistered":
        eventTypeText = t("ptl registered");
        break;
      case "BinModeChange":
        switch (event.event.binMode) {
          case "P":
            eventTypeText = t("bin in position");
            break;
          case "G":
            eventTypeText = t("bin to grid");
            break;
          case "C":
            eventTypeText = t("bin closed");
            break;
          case "O":
            eventTypeText = t("bin opened");
            break;
        }
        break;
      case "BinRequested":
        eventTypeText = t("bin requested");
        break;
      case "PortError":
        eventTypeText = t("port error");
        break;
      case "PortMode":
        eventSupplementalText = event.event.portMode;
        eventTypeText = t("port mode");
        if (event.event.portMode === "Closed") {
          eventTextColor = "white";
        }
        break;
      default:
        eventTypeText = event.case;
        break;
    }
  } else if (isHandToggled(event)) {
    eventTypeText = event.case;
  }
  const dateObject = getTimeFromDatetime(timestamp);

  return (
    <Button
      sx={{
        backgroundColor: mapEventColorAndLetters(andonEvent).color,
        height: "100px",
        width: "30%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        cursor: "pointer",
        marginTop: "10px",
        flex: "0 0 auto",
        flexDirection: "column",
        color: eventTextColor
      }}
      onClick={onClickCb}
    >
      <Typography>{hub}</Typography>
      <Typography>{`${dateObject.hours}:${dateObject.minutes}:${dateObject.seconds}.${dateObject.milliseconds}`}</Typography>
      <Typography>{`${eventTypeText}`}</Typography>
      <Typography>{`${eventSupplementalText || " "}`}</Typography>
      <Typography>{`${binId || " "}`}</Typography>
      <Typography>{`${status || " "}`}</Typography>
    </Button>
  );
}

export default EventInfoBox;
